import { seatPose } from '../2-controllers/meeting/peers';
import { HOOKS } from '../3-store/core/hooks';

// 모듈(meeting)을 core에 이어 붙이는 곳. core는 meeting을 가져오지 않고 표(HOOKS)만 갖는다. 모험(game)은 옛 스크립트라 아직 표 밖에 있다(5단계).
// main.ts가 시작할 때 한 번 부른다. 표마다 넣는 순서가 부르는 순서다.
export function registerModules() {
  HOOKS.peerPose.push(seatPose);
}
